<template>
  <v-content class="pb-0">
    <v-navigation-drawer app temporary v-model="sideNav">
      <v-list nav>
        <v-list-item>
          <v-list-item-avatar horizontal height="auto" class="mx-auto">
            <v-img :src="require('@/assets/iconLogo.png')" class="py-1"></v-img>
          </v-list-item-avatar>
          <v-list-item-title class="body-2 ml-4"
            >ASISTENCIA REGIONAL</v-list-item-title
          >
        </v-list-item>
        <v-divider></v-divider>

        <v-list-group active-class="deep-purple--text text--accent-4">
          <v-list-item slot="activator">
            <v-list-item-content>
              <v-list-item-title> UBICACIÓN DE PROVEEDORES </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="{ name: 'ProveedoresElSalvador' }">
            <v-list-item-action>
              <i class="fas fa-map-marked-alt"></i>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title> El Salvador </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="{ name: 'ProveedoresGuatemala' }">
            <v-list-item-action>
              <i class="fas fa-map-marked-alt"></i>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title> Guatemala </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="{ name: 'ProveedoresHonduras' }">
            <v-list-item-action>
              <i class="fas fa-map-marked-alt"></i>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title> Honduras </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="{ name: 'ProveedoresNicaragua' }">
            <v-list-item-action>
              <i class="fas fa-map-marked-alt"></i>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title> Nicaragua </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="{ name: 'ProveedoresCostaRica' }">
            <v-list-item-action>
              <i class="fas fa-map-marked-alt"></i>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title> Costa Rica </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="{ name: 'ProveedoresPanama' }">
            <v-list-item-action>
              <i class="fas fa-map-marked-alt"></i>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title> Panamá </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item-group active-class="deep-purple--text text--accent-4">
          <v-list-item :to="{ name: 'NuestroServicios' }">
            <v-list-item-action>
              <i class="fas fa-tasks"></i>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title> NUESTROS SERVICIOS </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{ name: 'OtrosServicios' }">
            <v-list-item-action>
              <i class="fas fa-tasks"></i>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title> OTROS SERVICIOS </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{ name: 'Contactanos' }">
            <v-list-item-action>
              <i class="fas fa-id-card"></i>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title> CONTACTOS </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>

        <v-list-group active-class="deep-purple--text text--accent-4">
          <v-list-item slot="activator">
            <v-list-item-content>
              <v-list-item-title> SIGUENOS </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            href="https://www.facebook.com/Asistencia-Regional-100590618415592/"
            target="_blank"
          >
            <v-list-item-action>
              <i class="fab fa-facebook-f fa-2x"></i>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title> FACEBOOK </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            href="https://www.instagram.com/asistencia_regional/?hl=es-la"
          >
            <v-list-item-action>
              <i class="fab fa-instagram fa-2x"></i>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title> INSTAGRAM </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item href="https://twitter.com/Asis_Regional">
            <v-list-item-action>
              <i class="fab fa-twitter fa-2x"></i>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title> TWITTER </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      color="#00339F"
      dark
      shrink-on-scroll
      fade-img-on-scroll
      dense
      min-height="55"
      src="https://picsum.photos/1920/1080?random"
    >
      <v-app-bar-nav-icon
        class="my-auto hidden-lg-and-up"
        @click.native.stop="sideNav = !sideNav"
      >
      </v-app-bar-nav-icon>

      <router-link class="my-auto mr-2" to="/">
        <v-img
          class="my-auto"
          contain
          :src="require('@/assets/iconLogo.png')"
          transition="scale-transition"
          width="55"
          height="55"
        />
      </router-link>

      <router-link class="my-auto mr-2" to="/">
        <v-toolbar-title
          style="color: white"
          class="my-auto"
          :class="[$vuetify.breakpoint.mdAndUp ? 'title' : 'subtitle-1']"
        >
          ASISTENCIA REGIONAL
        </v-toolbar-title>
      </router-link>

      <template v-slot:img="{ props }">
        <v-img
          v-bind="props"
          gradient="to top right, rgba(127,159,244), rgba(10,73,244)"
        ></v-img>
      </template>

      <v-spacer></v-spacer>

      <v-toolbar-items
        class="hidden-md-and-down"
        :class="[$vuetify.breakpoint.mdAndUp ? 'body-1' : 'caption']"
      >
        <v-row>
          <div class="my-auto">
            <v-btn text :to="{ name: 'NuestroServicios' }"
              >NUESTROS SERVICIOS</v-btn
            >
          </div>

          <div class="my-auto">
            <v-menu
              open-on-hover
              offset-y
              transition="scale-transition"
              origin="center center"
            >
              <template v-slot:activator="{ on }">
                <v-btn color="#FFFFFF" text dark v-on="on">
                  <i class="fas fa-angle-down fa-2x mr-1"></i>
                  UBICACIÓN DE PROVEEDORES
                </v-btn>
              </template>
              <v-list shaped class="blue darken-1">
                <v-list-item
                  dark
                  color="blue lighten-5"
                  v-for="(item, index) in itemsUbicGeo"
                  :key="index"
                  router
                  :to="item.route"
                >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <div class="my-auto">
            <v-btn text :to="{ name: 'OtrosServicios' }">OTROS SERVICIOS</v-btn>
          </div>

          <div class="my-auto">
            <v-btn text :to="{ name: 'Contactanos' }">CONTACTOS</v-btn>
          </div>

          <div class="my-auto" v-if="logueado">
            <v-btn text :to="{ name: 'AssaAsistencias' }">ASSA MOVIL</v-btn>
          </div>

          <v-divider vertical inset></v-divider>

        </v-row>
      </v-toolbar-items>
    </v-app-bar>
  </v-content>
</template>

<script>
import { dbRefAppMovil } from "../main";
export default {
  data() {
    return {
      sideNav: false,
      itemsUbicGeo: [
        { title: "El Salvador", route: "/proveedoresElSalvador" },
        { title: "Guatemala", route: "/proveedoresGuatemala" },
        { title: "Honduras", route: "/proveedoresHonduras" },
        { title: "Nicaragua", route: "/proveedoresNicaragua" },
        { title: "Costa Rica", route: "/proveedoresCostaRica" },
        { title: "Panama", route: "/proveedoresPanama" },
      ],
      hidden: false,
      logueado: false
    };
  },
  created() {
    this.verificarAuth();
  },
  methods: {
      verificarAuth() {
          let me = this;
      dbRefAppMovil.auth().onAuthStateChanged(function (user) {
        if (user) {
          //console.log("si esta logueado Header");
          me.logueado = true;
        } else {
          //console.log("no esta logueado Header");
          me.logueado = false;
        }
      });
    },
  }
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
